import { PassportDefaultPage, PassportMenuPage } from '../components/PassportPage'
import { SignInWidget, SignUpWidget } from '../widgets/SignInUp'
import ForgotPasswordWidget from '../widgets/ForgotPassword'
import ResetPasswordWidget from '../widgets/ResetPassword'
import UpdatePasswordWidget from '../widgets/UpdatePassword'
import ResetPWDExpired from '../widgets/ResetPWDExpired'
import ParentsVerification from '../widgets/ParentsVerification'
import SilentSigninWidget from '../widgets/SilentSignin'
import { VerificationDeclined } from '../components/ParentsVerification'
import PrivacyManagement from '../widgets/PrivacyManagement'
import Wallet from '../widgets/Wallet'
import UserProfileWidget from '../widgets/UserProfile'
import ShippingAddressManagement from '../widgets/ShippingAddressManagement'
import SecuritySettingWidget from '../widgets/SecuritySetting'
import UpdateAccountWidget from '../widgets/UpdateAccount'

import { merge } from '../shared/utils/commonUtils'

const PAGE_PREFIX = '/page'
const defaultRouteConfig = {
  path: PAGE_PREFIX,
  pageConfig: {
    Page: PassportDefaultPage,
    widget: SignInWidget,
    titleKey: 'title.login',
  },
}

const ROUTES = [
  {
    path: `${PAGE_PREFIX}/signin`,
    pageConfig: {
      widget: SignInWidget,
      titleKey: 'title.login',
    },
  },
  {
    path: `${PAGE_PREFIX}/b2c`,
    pageConfig: {
      widget: SilentSigninWidget,
      titleKey: 'title.login',
      pageMode: 'content',
    },
  },
  {
    path: `${PAGE_PREFIX}/reg`,
    pageConfig: {
      widget: SignUpWidget,
      titleKey: 'title.reg',
    },
  },
  {
    path: `${PAGE_PREFIX}/forgotPwd`,
    pageConfig: {
      widget: ForgotPasswordWidget,
      titleKey: 'title.getPwd',
    },
  },
  {
    path: `${PAGE_PREFIX}/resetPwd/expired`,
    pageConfig: {
      widget: ResetPWDExpired,
      titleKey: 'title.resetPwd',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/updatePassword`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: UpdatePasswordWidget,
      titleKey: 'title.updatePassword',
      sideType: 'updatePassword',
    },
  },
  {
    path: `${PAGE_PREFIX}/resetPwd`,
    pageConfig: {
      widget: ResetPasswordWidget,
      titleKey: 'title.resetPwd',
    },
  },
  {
    path: `${PAGE_PREFIX}/verify`,
    pageConfig: {
      widget: ParentsVerification,
      titleKey: 'title.verification',
      pageMode: 'fullpage',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/userProfile`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: UserProfileWidget,
      titleKey: 'title.userProfile',
      sideType: 'userProfile',
    },
  },
  {
    path: `${PAGE_PREFIX}/verificationDeclined`,
    pageConfig: {
      widget: VerificationDeclined,
      titleKey: 'title.verification',
      pageMode: 'fullpage',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/privacy`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: PrivacyManagement,
      titleKey: 'title.privacy.management',
      sideType: 'privacy',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/wallet`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: Wallet,
      titleKey: 'title.wallet',
      sideType: 'wallet',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/shippingAddress`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: ShippingAddressManagement,
      titleKey: 'title.shipping.address.management',
      sideType: 'shippingAddress',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/securitySetting`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: SecuritySettingWidget,
      titleKey: 'title.security.setting.management',
      sideType: 'securitySetting',
    },
  },
  {
    path: `${PAGE_PREFIX}/account/updateAccount`,
    pageConfig: {
      Page: PassportMenuPage,
      widget: UpdateAccountWidget,
      titleKey: 'title.update.account.management',
      sideType: 'updateAccount',
    },
  }
]

const DEFAULT_PAGE_CONFIG = { pageConfig: { Page: PassportDefaultPage } }

export default ROUTES.map(r => merge(DEFAULT_PAGE_CONFIG, r))

export { defaultRouteConfig }
